export default httpClient => ({
    save: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/eventos', dados, { headers });
        console.log(dados)
        return {
            data: response.data
        }
    },
    update: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/eventos/' + dados.get('id'), dados, { headers });
        return {
            data: response.data
        }
    },
    getById: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/eventos/' + id, { headers });
        return {
            data: response.data
        }
    },
    getAll: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/eventos', { headers });
        return {
            data: response.data
        }
    },
    delete: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/eventos/' + id, { headers });
        return {
            data: response
        }
    },
    deletarImagem: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/deletar-imagem/' + id, { headers });
        return {
            data: response
        }
    },
    getAllSite: async () => {
        const response = await httpClient.get('/eventos-site/1');
        return {
            data: response.data
        }
    },
    eventoNome: async ({ titulo_url }) => {
        const response = await httpClient.get('/evento/' + titulo_url);
        return {
            data: response.data
        }
    },
});